module.exports = __webpack_public_path__ + "img/cocacola-bg@2x.687cd2dd.png";